document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.announces-wrapper').forEach(function (wrapper) {
    const swiperEl = wrapper.querySelector('.swiper');
    new Swiper(swiperEl, {
      loop: true,
      speed: 1200,
      pagination: {
        el: wrapper.querySelector('.swiper-pagination'),
        clickable: true
      },
      navigation: {
        nextEl: wrapper.querySelector('.swiper-button-next'),
        prevEl: wrapper.querySelector('.swiper-button-prev'),
      },
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      }
    });
  });
});